import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, Navigate } from 'react-router-dom';
import { 
  Home, FileText, User, Mountain, Calculator,
  ChevronLeft, ChevronRight, LogOut
} from 'lucide-react';
import './App.css';

import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentDetail from './pages/DocumentDetail';
import Profil from './pages/Profil';
import TarifCalcul from './pages/TarifCalcul';
import Login from './pages/Login';
import { clientConnecte } from './data/mockData';

const Navigation = ({ isCollapsed, setIsCollapsed, onLogout }) => {
  const location = useLocation();
  
  const navItems = [
    { section: 'Navigation' },
    { path: '/', icon: Home, label: 'Tableau de bord' },
    { path: '/documents', icon: FileText, label: 'Mes documents' },
    { path: '/tarifs', icon: Calculator, label: 'Calcul de tarifs' },
    { path: '/profil', icon: User, label: 'Mon profil' },
  ];

  return (
    <nav className={`navigation ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="nav-header">
        <div className="nav-brand">
          <Mountain className="brand-icon" />
          {!isCollapsed && <h1>GONTERO</h1>}
        </div>
        <button className="nav-toggle" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      {!isCollapsed && (
        <div className="nav-user">
          <div className="user-avatar">
            {clientConnecte.prenom[0]}{clientConnecte.nom[0]}
          </div>
          <div className="user-info">
            <p className="user-name">{clientConnecte.prenom} {clientConnecte.nom}</p>
            <p className="user-role">{clientConnecte.raisonSociale}</p>
          </div>
        </div>
      )}

      <ul className="nav-menu">
        {navItems.map((item, index) => {
          if (item.section) {
            return !isCollapsed && (
              <li key={index} className="nav-section">{item.section}</li>
            );
          }
          const Icon = item.icon;
          const isActive = item.path === '/' 
            ? location.pathname === '/' 
            : location.pathname.startsWith(item.path);
          return (
            <li key={index}>
              <NavLink
                to={item.path}
                className={`nav-link ${isActive ? 'active' : ''}`}
                title={isCollapsed ? item.label : ''}
              >
                <Icon size={20} />
                {!isCollapsed && <span>{item.label}</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>

      <div className="nav-footer">
        {!isCollapsed && (
          <>
            <div className="nav-footer-actions">
              <button className="btn-icon" title="Déconnexion" onClick={onLogout}>
                <LogOut size={18} />
              </button>
            </div>
            <div className="nav-footer-info">
              <p>Espace Client</p>
              <strong>GONTERO Carrières</strong>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <Router>
      <div className="app">
        <Navigation 
          isCollapsed={sidebarCollapsed} 
          setIsCollapsed={setSidebarCollapsed}
          onLogout={() => setIsLoggedIn(false)}
        />
        <main className={`main-content ${sidebarCollapsed ? 'sidebar-closed' : ''}`}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/documents/:id" element={<DocumentDetail />} />
            <Route path="/tarifs" element={<TarifCalcul />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
